import { render } from "./QHLSCenterEditRequests.vue?vue&type=template&id=b80e7066&scoped=true"
import script from "./QHLSCenterEditRequests.vue?vue&type=script&lang=js"
export * from "./QHLSCenterEditRequests.vue?vue&type=script&lang=js"

import "./QHLSCenterEditRequests.vue?vue&type=style&index=0&id=b80e7066&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b80e7066"]])

export default __exports__